import { createLazyFileRoute } from '@tanstack/react-router';

import { DefaultLayout } from '@src/layout';
import ServiceAdvisoryPage from '@src/pages/Services/Advisory';

export const Route = createLazyFileRoute('/services/advisory')({
  component: ServiceAdvisoryPageWithLayout,
});

function ServiceAdvisoryPageWithLayout() {
  return (
    <DefaultLayout>
      <ServiceAdvisoryPage />
    </DefaultLayout>
  );
}
